<template>
  <div class="mk-bank-button"
       :class="{disabled:disabledBtn}"
       :style="{background}"
       v-tooltip="disabledBtn && disabledTooltip"
       @click="!disabledBtn ? $emit('click') : false">
    <div class="mk-bank-button__icon">
      <img :src="icon || logo" :alt="`${name}_logo`">
    </div>
    <div class="mk-bank-button__name" :style="{color}">
      {{ name }}
    </div>
  </div>
</template>

<script>

export default {
  name: "MKBankButton",
  props: {
    icon: {
      type: String,
    },
    logo: {
      type: String
    },
    name: {
      type: String,
      required: true
    },
    color: {
      type: String,
      required: true
    },
    background: {
      type: String,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    nextRefreshAt: {
      type: Number,
    }
  },
  data() {
    return {
      secondsBeforeRefreshAvailable: null,
    }
  },
  computed: {
    disabledBtn() {
      return this.secondsBeforeRefreshAvailable > 0 || this.disabled;
    },
    disabledTooltip() {
      if (this.nextRefreshAt) {
        let moment = this.$moment.unix(this.nextRefreshAt),
            date = moment.format('DD.MM.YYYY'),
            time = moment.format('HH:mm');
        return this.$t('refreshWillBeAvailable', {date, time})
      } else {
        return this.$t('syncIsUnavailable')
      }
    },
  },
  methods: {
    setTimer() {
      if (this.nextRefreshAt) {
        this.secondsBeforeRefreshAvailable = this.$moment.unix(this.nextRefreshAt).diff(this.$moment(), 'seconds')
      }
    }
  },
  watch: {
    secondsBeforeRefreshAvailable: {
      immediate: true,
      handler(val) {
        if (!!val && val >= 0) {
          setTimeout(() => {
            this.secondsBeforeRefreshAvailable -= 60;
          }, 1000 * 60)
        }
      }
    },
    nextRefreshAt: {
      immediate: true,
      handler: 'setTimer'
    }
  },
  i18n: {
    messages: {
      en: {
        refreshWillBeAvailable: 'Synchronization will be available on {date} at {time}',
        syncIsUnavailable: 'Synchronization is unavailable'
      },
      ru: {
        refreshWillBeAvailable: 'Синхронизация будет доступна {date} в {time}',
        syncIsUnavailable: 'Синхронизация недоступна'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.mk-bank-button {
  @apply flex rounded overflow-hidden cursor-pointer;

  &__icon {
    @apply w-16 h-16 flex items-center justify-center py-2;
    background: rgba(0, 0, 0, 0.1);

    img {
      @apply h-full;
    }
  }

  &__name {
    @apply flex-1 text-md font-bold text-center self-center truncate px-4;
  }

  &.disabled {
    cursor: not-allowed;
    opacity: .5;
  }
}
</style>